<template>
    <div id="espacio">
        <b-container fluid>
            <b-row>
                <b-col class="col-img" lg="6">
                </b-col>
                <b-col class="col-color" lg="6">
                    <h4>Nuestro espacio</h4>
                    <p>Nuestras oficinas y el taller Kokolet están pensados para promover la creatividad, la colaboración y la conexión, convirtiéndose en el motor de todas las actividades y eventos que organizamos.</p>
                    <p>Además, buscamos ir más allá de nuestro espacio físico, creando una comunidad diversa a través de talleres, cursos y eventos que invitan a personas de todas las edades e intereses.</p>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    export default {

    }
</script>

<style scoped>
.col-color{
    background: #BC8F50;
    padding: 10% 5%;
    color: #fff;
}
.col-img{
    background: url('../assets/img/imgnuestroespacio.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}
h4{
    font-size: 30px;
    margin-bottom: 25px;
}
p{
    font-size: 20px;
}
@media (max-width: 992px){
    p{
        font-size: 18px;
    }
}
</style>